// @ts-ignore
import { Notification } from "../../utils";
import t from "./t";

const showNotification: (msgType: string, itemId: (string | null), apiMsg?: (string | null), type?: string, raute?: (boolean | null), del?: (boolean | null)) => void = (
    msgType:string , itemId:null|string, apiMsg?:null|string, type:string = 'resource', raute:null|boolean = true, del:null|boolean = false):void => {
    // little delay necessary to make notifications visible (render of background must be done before)
    setTimeout( ():void => {
      if (msgType === 'success') {
          let tString:string = (del?'deleted':'stored');
          if(typeof apiMsg !== 'undefined' && apiMsg !== null){
              tString = apiMsg;
          }
          tString += '_${a}';
            new Notification({
              message : t(tString,{a:t(type)},'capital')+ (raute?' #':' ') + (itemId !== null?itemId:''),
              duration : 5000,
              type : 'success',
              closeable : true,
              icon : 'fi fi-check'
            });
          } else if (msgType === 'warning') {
            new Notification({
              message : (typeof apiMsg !== 'undefined' && apiMsg !== null) ? t(apiMsg,null,'capital') : t('request_error',null,'capital'),
              duration : 5000,
              type : 'warning',
              closeable : true,
              icon : 'fi fi-x'
            });
          } else if (msgType === 'else if (msgType === \'warning\') {\n' +
          '            new Notification({\n' +
          '              message : (typeof apiMsg !== \'undefined\' && apiMsg !== null) ? t(apiMsg,null,\'capital\') : t(\'request_error\',null,\'capital\'),\n' +
          '              duration : 5000,\n' +
          '              type : \'warning\',\n' +
          '              closeable : true,\n' +
          '              icon : \'fi fi-x\'\n' +
          '            });\n' +
          '          } ') {
          new Notification({
              message : (typeof apiMsg !== 'undefined' && apiMsg !== null) ? t(apiMsg,null,'capital') : null,
              duration : 5000,
              type : 'success',
              closeable : true,
              icon : 'fi fi-check'
          });
      } else {
              new Notification({
                  message : (typeof apiMsg !== 'undefined' && apiMsg !== null) ? t(apiMsg,null,'capital') : t('request_error',null,'capital'),
                  duration : 5000,
                  type : 'default',
                  closeable : true,
                  icon : 'fi fi-x'
              });
          }

    },200);
    
  };

export default showNotification;